"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findIndex;
function findIndex(arr) {
  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
    return x;
  };

  if (!arr) {
    return -1;
  }

  var i = -1;
  while (++i < arr.length) {
    if (fn(arr[i])) {
      return i;
    }
  }

  return -1;
}


//////////////////
// WEBPACK FOOTER
// ../dist/utils/findIndex.js
// module id = 894
// module chunks = 0